import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function TextRotationAngledownIcon(props: IconProps) {
    return <Icon {...props} iconKey={"text_rotation_angledown"}/>
}
